// extracted by mini-css-extract-plugin
export var statItem = "_l8-1";
export var statsRow = "_l8-0";